import {
  faCarSide,
  faHouseUser,
  faLaptop,
  faList,
  faPhone,
  faQuestionCircle,
  faSearch,
  faSignOutAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconSvg } from '@prism/icon'
import { RdpAccountSettingIcon } from 'images/icon/AccountSettingIcon'
import { CurrentBidIcon } from 'images/icon/CurrentBidIcon'
import { SaveSearchIcon } from 'images/icon/SaveSearchIcon'
import { AdvanceSearchIcon } from '../images/icon/AdvanceSearchIcon'

export const iconDict = {
  RDP_MyDashboard: <FontAwesomeIcon icon={faHouseUser} />,
  RDP_News: <FontAwesomeIcon icon={faList} />,
  RDP_GroundVehicle: <FontAwesomeIcon icon={faCarSide} />,
  RDP_SearchResults: <FontAwesomeIcon icon={faSearch} />,
  RDP_SearchResults_2: <FontAwesomeIcon icon={faSearch} />,
  RDP_AdvancedSearch: <AdvanceSearchIcon />,
  RDP_SavedSearch: <SaveSearchIcon />,
  RDP_WatchList: <IconSvg glyph="eye" />,
  RDP_CurrentBids: <CurrentBidIcon />,
  RDP_WatchList_2: <IconSvg glyph="eye" />,
  RDP_CurrentBids_2: <CurrentBidIcon />,
  RDP_MyProfile: <FontAwesomeIcon icon={faUser} />,
  RDP_ContactUs: <FontAwesomeIcon flip="horizontal" icon={faPhone} />,
  RDP_ManageUsers: <FontAwesomeIcon icon={faUser} />,
  RDP_AccountSettings: <RdpAccountSettingIcon />,
  RDP_ManageDevices: <FontAwesomeIcon icon={faLaptop} />,
  FAQ: <FontAwesomeIcon icon={faQuestionCircle} />,
  Logout: <FontAwesomeIcon icon={faSignOutAlt} />
}
